import {NgModule} from '@angular/core';
import {
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTreeGridModule,
} from '@nebular/theme';
import {NbEvaIconsModule, NbEvaSvgIcon} from '@nebular/eva-icons';

@NgModule({
  declarations: [],
  imports: [
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbInputModule,
    NbIconModule,
    NbEvaIconsModule,
    NbSelectModule,
    NbSpinnerModule,
    NbLayoutModule,
  ],
  exports: [
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbInputModule,
    NbIconModule,
    NbEvaIconsModule,
    NbSelectModule,
    NbSpinnerModule,
    NbLayoutModule,
  ],
})
export class NbModule {}
